/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// international regex taken from
// https://stackoverflow.com/questions/2113908/what-regular-expression-will-match-valid-international-phone-numbers
export const phoneNumberRegex = /^(6|8|9)[0-9]{7}$/;

export function isPhoneNumber(text: string) {
  return phoneNumberRegex.test(text);
}
